var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSta2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 77,
    viewBox: "0 0 71 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_704_7017",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 9,
    width: 51,
    height: 68
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.4623 32.3397L60.0497 9.06787L68.9478 15.9125C69.6322 20.9319 71.0012 32.6135 71.0012 39.1844V65.1941L37.4623 76.1455L21.0352 59.7184L36.0934 46.7135L37.4623 32.3397Z",
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_704_7017)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1948 60.9504C20.3501 54.3795 15.8326 43.7018 21.0346 33.8455L27.1948 22.0727C29.1113 23.031 31.1647 22.8941 33.0812 21.662C34.8608 20.43 35.819 18.6504 35.819 16.4601C41.4317 16.4601 47.3181 17.1445 51.8355 18.6504C55.121 21.5251 58.5433 25.7688 61.1443 30.1494C61.2812 30.4232 61.2812 31.5183 61.1443 31.6552C59.5016 32.7504 58.6802 34.3931 58.5433 36.3096C58.5433 37.131 58.5433 37.9523 58.8171 38.6368C59.0909 39.4581 59.9122 40.1426 60.5967 40.2795C60.7336 40.5533 61.0074 41.2378 61.0074 41.6484L54.0258 52.7368C47.7287 62.1824 36.3666 63.6882 27.1948 60.9504Z",
    fill: "url(#paint0_linear_704_7017)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7866 59.7184C19.9419 53.1475 15.4244 42.4698 20.6264 32.6135L26.6497 20.7038C28.5662 21.6621 30.6196 21.5252 32.5361 20.2931C34.3157 19.0611 35.2739 17.2815 35.2739 15.0912C40.8866 15.0912 46.773 15.7757 51.2904 17.2815C54.8497 20.43 58.272 25.2213 61.1468 30.0125C59.2302 30.9708 58.1351 32.7504 57.9982 34.9407C57.8613 37.131 58.8196 38.9106 60.5992 40.1426L53.4807 51.3679C47.3205 60.9504 35.8215 62.4562 26.7866 59.7184Z",
    fill: "url(#paint1_radial_704_7017)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7851 59.7183L51.152 17.4183C46.6346 15.9125 40.7482 15.228 35.1355 15.228C35.2724 17.4183 34.3142 19.1979 32.3977 20.43C30.755 21.5251 28.5647 21.662 26.6482 20.7038L20.488 32.4766C15.4229 42.4698 19.8035 53.1474 26.7851 59.7183Z",
    fill: "url(#paint2_radial_704_7017)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.648 20.0195C45.815 18.9243 41.5713 18.3768 37.6014 18.2399C37.0539 20.1564 35.8218 21.7991 34.0422 22.8942C32.2626 24.1263 30.2092 24.537 28.1558 24.2632L23.0908 33.9826C18.8471 42.0593 22.1325 51.0942 28.1558 57.1175C36.5063 59.3078 45.815 57.6651 50.7432 49.8622L56.6296 40.6904C55.3976 39.0476 54.7131 36.9942 54.85 34.8039C54.9869 32.7505 55.8082 30.834 57.0403 29.3282C55.1238 26.1797 52.5228 22.6205 49.648 20.0195Z",
    fill: "url(#paint3_linear_704_7017)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.6485 20.0195L28.1562 57.1176C36.5067 59.3079 45.8155 57.6652 50.7436 49.8623L56.63 40.6904C55.398 39.0477 54.7135 36.9943 54.8504 34.804C54.9873 32.7506 55.8087 30.8341 57.0407 29.3283C55.1242 26.1797 52.5232 22.6205 49.6485 20.0195Z",
    fill: "url(#paint4_linear_704_7017)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0902 49.8621C28.9766 39.3214 35.1368 28.7806 41.297 18.3767C41.1601 18.3767 40.8863 18.3767 40.7494 18.3767C34.9999 28.7806 29.1135 39.1845 22.8164 49.3146C22.9533 49.5884 23.0902 49.7253 23.0902 49.8621Z",
    fill: "#1D71B8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.3749 19.8826C42.3933 32.3399 35.2749 44.6602 28.0195 56.8437L28.1564 56.9806C28.2933 56.9806 28.2933 56.9806 28.4302 56.9806C35.4118 44.5233 42.5302 32.203 49.7856 20.0195L49.6487 19.8826C49.5118 19.8826 49.5118 19.8826 49.3749 19.8826Z",
    fill: "#1D71B8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.918 57.9389C43.0782 47.535 49.1015 36.9943 55.1248 26.4535C55.2617 26.5904 55.3986 26.7273 55.3986 26.8642C49.2384 37.1312 43.2151 47.3982 37.4655 57.802C37.3286 57.802 37.1918 57.9389 36.918 57.9389Z",
    fill: "#722935"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.8856 20.8407C41.8439 20.2932 45.1293 20.9776 46.0875 21.3883C46.4982 21.5252 46.9089 21.799 47.0458 22.2097C47.4565 22.6203 47.4565 23.1679 47.3196 23.7155C48.0041 22.4835 48.6885 21.2514 49.373 20.0194C46.772 19.198 44.0341 18.7873 41.2963 18.5135C40.4749 20.0194 39.5167 21.5252 38.6953 23.031C39.2429 22.0728 40.0642 21.2514 40.8856 20.8407Z",
    fill: "url(#paint5_radial_704_7017)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.3433 27.9593C53.3433 26.8641 51.0161 24.4001 50.1947 23.7156C49.784 23.4418 49.3734 23.3049 48.9627 23.168C48.4151 23.0311 48.0044 23.3049 47.5938 23.7156C48.4151 22.6204 49.0996 21.3884 49.784 20.1564C51.7005 21.936 53.4802 24.1263 55.1229 26.4535C54.3015 27.9593 53.3433 29.4651 52.5219 30.9709C52.9326 30.0127 53.3433 28.9175 53.3433 27.9593Z",
    fill: "url(#paint6_radial_704_7017)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6093 54.5167C25.9666 53.2846 24.7345 50.5468 24.7345 48.4934C24.7345 47.672 24.8714 46.8507 25.1452 46.0293C24.4607 47.2613 23.7763 48.4934 23.0918 49.7254C24.3238 52.3264 25.9666 54.6536 28.02 56.707C28.4306 56.2963 28.8413 55.6118 29.1151 54.9274C28.7044 55.2011 28.4306 55.2011 27.6093 54.5167Z",
    fill: "url(#paint7_radial_704_7017)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.618 56.2961C32.5345 57.1175 35.5462 56.7068 37.1889 55.7486C38.0103 55.3379 38.5578 54.7903 39.1054 54.1058C38.4209 55.3379 37.5996 56.5699 36.9151 57.802C34.0404 58.0757 31.1656 57.802 28.4277 56.9806C28.8384 56.2961 29.1122 55.7486 29.5229 55.0641C29.5229 55.6117 29.7967 55.8854 30.618 56.2961Z",
    fill: "url(#paint8_radial_704_7017)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2264 44.934C21.5837 42.4699 21.9944 37.8155 22.8157 34.667C20.6254 39.5951 20.8992 44.6602 22.9526 49.3146C23.6371 48.0825 24.4584 46.7136 25.2798 45.4816C24.5953 45.8922 23.9109 46.0291 23.2264 44.934Z",
    fill: "url(#paint9_radial_704_7017)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.1608 55.3379C44.1724 55.4748 48.0054 52.8738 50.3326 50.5466C47.1841 54.9272 42.5297 57.1175 37.6016 57.802C38.286 56.433 39.1074 55.201 39.7919 53.8321C39.655 54.6534 39.9287 55.3379 41.1608 55.3379Z",
    fill: "url(#paint10_radial_704_7017)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.7969 31.3817C53.7551 30.5604 54.1658 31.1079 53.892 32.6138C53.0707 37.6788 54.0289 38.6371 54.7134 41.9225C54.8503 42.8808 54.5765 43.839 54.0289 44.7973L56.6299 40.6905C55.3978 39.0478 54.7134 36.9944 54.8503 34.8041C54.9872 32.7507 55.8085 30.8342 57.0406 29.3283C56.9037 29.0545 56.6299 28.7808 56.493 28.507C56.0823 27.9594 55.6716 27.4118 55.261 26.8643C54.5765 28.3701 53.6182 29.8759 52.7969 31.3817Z",
    fill: "url(#paint11_radial_704_7017)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.1494 22.8942C38.4232 21.6622 37.4649 22.3467 36.2329 23.4418C33.2212 26.1797 31.3047 26.5904 28.8406 27.2748C26.9241 27.8224 26.2397 28.37 25.1445 29.7389L28.0193 24.2632C30.0727 24.537 32.1261 24.1263 33.9057 22.8942C35.6853 21.7991 36.9173 20.1564 37.4649 18.2399C37.8756 18.2399 38.1494 18.2399 38.5601 18.2399C39.2445 18.2399 39.929 18.3768 40.6135 18.3768C39.929 19.8826 39.1076 21.3884 38.1494 22.8942Z",
    fill: "url(#paint12_radial_704_7017)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1855 46.7137C25.9652 43.2914 28.2923 39.1846 30.8933 34.6671C33.4943 30.1496 35.9584 26.1797 38.0118 22.8943C36.2321 26.3166 33.905 30.4234 31.304 34.9409C28.703 39.3215 26.2389 43.4283 24.1855 46.7137Z",
    fill: "#99FFFF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4277 55.7487C31.0287 50.9575 34.3141 45.0711 38.0103 38.774C41.5695 32.4769 44.9918 26.7274 47.8666 22.073C45.2656 26.8643 41.9802 32.7507 38.284 39.0478C34.7248 45.3448 31.3025 51.0944 28.4277 55.7487Z",
    fill: "#99FFFF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4219 54.9273C40.2015 51.505 42.5287 47.3982 45.1296 42.8807C47.7306 38.5001 50.1947 34.3933 52.2481 31.1079C50.4685 34.5302 48.1413 38.637 45.5403 43.1545C42.9394 47.5351 40.4753 51.6419 38.4219 54.9273Z",
    fill: "#FF886C"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    },
    opacity: 0.5
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.2971 22.7574C39.7913 24.4001 38.6961 26.1797 37.601 28.0962C34.4524 33.0244 30.3456 39.5953 28.2922 45.071C27.7447 46.5768 27.334 48.0827 27.1971 49.7254C27.0602 51.0943 28.1554 55.338 29.6612 52.737C33.2204 46.5768 36.7796 40.4166 40.3388 34.2564C42.3922 30.8341 44.5825 27.2749 46.499 23.8526C47.5942 21.5254 43.2136 20.5671 41.2971 22.7574Z",
    fill: "url(#paint13_radial_704_7017)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    }
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.975 30.1495C48.9634 35.4884 42.1187 47.535 39.6547 51.6418C38.8333 53.0107 37.4644 53.969 36.2323 54.9272C35.1372 55.7486 31.0304 56.9806 32.3993 54.2427C37.1906 45.3447 42.8032 35.2146 48.5527 26.0427C49.9216 23.9893 53.4809 27.4117 51.975 30.1495Z",
    fill: "url(#paint14_radial_704_7017)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    },
    opacity: 0.5
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9046 28.233C34.0415 28.0961 33.9046 27.6854 33.7677 27.6854C32.6725 27.1379 30.756 27.8223 29.7978 28.3699C29.1133 28.9175 28.5657 29.6019 28.1551 30.4233C25.8279 34.3932 24.4589 37.1311 23.9114 41.7854C23.6376 43.9757 24.7327 44.6602 26.1017 42.333C28.8395 37.5417 31.4405 32.8874 33.9046 28.233Z",
    fill: "url(#paint15_radial_704_7017)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    }
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.7418 38.7739C48.5516 42.1962 43.3496 50.9574 43.3496 52.4632C43.3496 53.5583 44.5817 53.2845 45.2661 53.1476C46.635 52.737 48.2778 51.6418 49.236 50.6836C50.7418 49.0409 53.2059 45.2078 53.6166 43.0176C53.8904 41.5117 53.4797 34.5302 50.7418 38.7739Z",
    fill: "url(#paint16_radial_704_7017)"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.774 34.8037L28.839 25.0843L28.1545 24.2629L23.0895 33.9824C19.6672 40.4163 21.173 47.6717 25.1429 53.4212C21.5837 47.8086 20.4885 41.1008 23.774 34.8037Z",
    fill: "url(#paint17_linear_704_7017)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.7019 25.0843C30.7553 25.3581 32.8087 24.9474 34.5883 23.7154C36.3679 22.6203 37.5999 20.9775 38.1475 19.061L37.5999 18.1028C37.0524 20.0193 35.8203 21.662 34.0407 22.7572C32.2611 23.9892 30.2077 24.3999 28.1543 24.1261L28.7019 25.0843Z",
    fill: "url(#paint18_linear_704_7017)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.286 19.061C42.2559 19.1979 46.4996 19.7455 50.3326 20.8406C52.6598 23.0309 54.8501 25.7688 56.6297 28.5067C54.7132 25.495 52.2491 22.3465 49.6482 19.8824C45.8152 18.7872 41.5715 18.2397 37.6016 18.1028L38.286 19.061Z",
    fill: "url(#paint19_linear_704_7017)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3867 21.3882C32.1246 21.662 35.2731 20.1562 36.5052 16.597C37.6003 15.228 42.3916 15.6387 44.7188 15.9125C41.7071 15.5018 38.4217 15.228 35.1362 15.228C35.2731 17.4183 34.3149 19.1979 32.3984 20.43C31.577 20.9775 30.4819 21.3882 29.3867 21.3882Z",
    fill: "url(#paint20_radial_704_7017)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6482 22.0727C27.0589 21.3882 27.7433 21.2513 28.4278 21.2513C27.8802 21.2513 27.1958 21.1144 26.6482 20.7037L20.488 32.4766C17.2026 38.9105 17.7501 45.4814 20.488 51.2309C19.5297 48.6299 18.7084 46.1659 18.7084 43.428C18.7084 37.2678 19.5297 34.8037 26.6482 22.0727Z",
    fill: "url(#paint21_radial_704_7017)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3337 25.9057C27.7444 25.7688 27.8812 26.3163 27.6075 26.727C26.923 28.2328 26.1016 29.7387 25.4172 31.1076C23.2269 35.4882 22.1317 36.994 21.5842 42.0591C21.4473 42.7435 21.4473 43.2911 21.4473 43.9756C21.8579 47.3979 23.2269 50.5464 25.2803 53.4212C21.7211 47.8086 20.6259 41.1008 23.9113 34.8037L28.9764 25.0843L28.155 24.2629L27.3337 25.9057Z",
    fill: "url(#paint22_radial_704_7017)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.8259 17.2815C49.5104 17.966 49.5104 19.3349 48.2784 19.4718C48.0046 19.4718 47.8677 19.4718 47.5939 19.4718C48.2784 19.6087 48.9628 19.8825 49.6473 20.0194L51.1531 17.4184C49.5104 16.8709 47.8677 16.4602 45.9512 16.1864C47.0463 16.3233 48.1415 16.5971 48.8259 17.2815Z",
    fill: "url(#paint23_radial_704_7017)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2366 56.0221C26.5104 56.7066 25.8259 57.9386 25.0046 57.3911C24.5939 57.1173 24.3201 56.8435 24.0463 56.5697C24.8677 57.6649 25.8259 58.76 26.9211 59.5814L28.4269 56.9804C26.0997 54.6532 24.1832 51.9153 22.9512 48.9037C23.4987 50.8202 24.457 52.4629 25.4152 54.2425C25.689 54.927 25.9628 55.6115 26.2366 56.0221Z",
    fill: "url(#paint24_radial_704_7017)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1944 60.9505L26.6469 59.7184C24.0459 57.2543 21.7187 54.1058 20.2129 50.6835C21.7187 54.6534 24.3197 58.2126 27.1944 60.9505Z",
    fill: "#234368"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.9155 19.7455C37.463 19.8824 37.3261 20.5669 36.9155 21.2513C35.4096 23.4416 32.9456 25.2212 30.2077 24.9474C29.6601 24.9474 29.2494 24.5368 29.3863 24.263C28.9757 24.263 28.565 24.263 28.1543 24.1261L28.7019 25.0843C30.7553 25.3581 32.8087 24.9474 34.5883 23.7154C36.3679 22.6203 37.5999 20.9775 38.1475 19.061L37.5999 18.1028C37.463 18.7872 37.1892 19.3348 36.9155 19.7455Z",
    fill: "url(#paint25_radial_704_7017)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.5926 19.335C48.0033 19.4719 48.8247 20.1563 47.5926 20.0194C46.9082 19.8825 46.2237 19.7456 45.4023 19.6087C44.0334 19.4719 42.6645 19.335 41.4324 19.1981C41.0218 19.1981 40.4742 19.0612 40.0635 19.0612C39.379 18.9243 38.9684 18.6505 38.9684 18.3767C38.5577 18.3767 38.147 18.3767 37.7363 18.3767L38.2839 19.335C42.2538 19.4719 46.4975 20.0194 50.3305 21.1146C52.6577 23.3049 54.848 26.0427 56.6276 28.7806C54.7111 25.7689 52.247 22.6204 49.646 20.1563C48.9616 19.7456 48.2771 19.6087 47.5926 19.335Z",
    fill: "url(#paint26_radial_704_7017)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.5632 18.6504C51.7001 18.6504 51.7001 18.6504 51.5632 18.6504C51.9738 18.5135 52.2476 18.6504 52.3845 18.6504C51.9738 18.2397 51.4263 17.829 51.0156 17.4183L50.468 18.3766L49.5098 20.0193L49.6467 20.1562C51.5632 21.9358 53.3428 24.1261 54.9855 26.4533C55.1224 26.5902 55.2593 26.7271 55.2593 26.864L55.3962 27.0009C54.5748 25.2212 52.5214 22.4834 51.2894 20.7038C51.0156 20.2931 51.0156 20.0193 51.0156 19.8824C51.0156 19.6086 51.2894 18.9242 51.5632 18.6504Z",
    fill: "url(#paint27_radial_704_7017)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.8594 34.2562C58.2701 33.0242 59.2283 31.3815 60.7341 31.7921C60.7341 31.7921 60.871 31.7921 60.871 31.6552C61.0079 31.3815 61.0079 30.4232 60.871 30.1494C59.3652 30.9708 58.2701 32.4766 57.8594 34.2562Z",
    fill: "url(#paint28_radial_704_7017)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.4628 61.6349C36.6415 61.6349 36.5046 61.2242 36.7784 60.8135C33.356 61.0873 29.9337 60.6766 26.7852 59.7184L27.3327 60.9504C36.3677 63.6883 47.8667 62.1825 53.89 52.7368L60.8716 41.6485C60.8716 41.2378 60.5978 40.5533 60.4609 40.2795L59.7764 41.3747C60.0502 42.0592 59.9133 42.6067 59.2288 43.565C58.1337 45.3446 55.6696 49.4514 53.4793 52.463C52.1104 54.3795 50.4677 56.1592 48.6881 57.665C45.8133 59.9922 41.2958 61.9087 37.4628 61.6349Z",
    fill: "url(#paint29_radial_704_7017)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_704_7017",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 51,
    height: 68
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0396 44.6602L11.4522 67.932L2.55418 61.0873C1.86971 56.0679 0.500778 44.3864 0.500778 37.8155V11.8058L34.0396 0.85434L50.4668 17.2815L35.4085 30.2864L34.0396 44.6602Z",
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_704_7017)"
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1928 60.9505C20.3481 54.3796 15.8307 43.702 21.0326 33.8456L27.1928 22.0728C29.1093 23.0311 31.1627 22.8942 33.0792 21.6621C34.8588 20.4301 35.8171 18.6505 35.8171 16.4602C41.4297 16.4602 47.3161 17.1447 51.8336 18.6505C55.119 21.5253 58.5414 25.7689 61.1423 30.1495C61.2792 30.4233 61.2792 31.5185 61.1423 31.6554C59.4996 32.7505 58.6782 34.3932 58.5414 36.3097C58.5414 37.1311 58.5414 37.9524 58.8151 38.6369C59.0889 39.4583 59.9103 40.1427 60.5948 40.2796C60.7316 40.5534 61.0054 41.2379 61.0054 41.6486L54.0239 52.7369C47.7268 62.1825 36.3647 63.6884 27.1928 60.9505Z",
    fill: "url(#paint30_linear_704_7017)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7846 59.7185C19.9399 53.1476 15.4225 42.4699 20.6244 32.6136L26.6477 20.7039C28.5642 21.6622 30.6176 21.5253 32.5341 20.2933C34.3137 19.0612 35.272 17.2816 35.272 15.0913C40.8846 15.0913 46.771 15.7758 51.2885 17.2816C54.8477 20.4301 58.27 25.2214 61.1448 30.0127C59.2283 30.9709 58.1331 32.7505 57.9963 34.9408C57.8594 37.1311 58.8176 38.9107 60.5972 40.1428L53.4788 51.368C47.3186 60.9505 35.8196 62.4564 26.7846 59.7185Z",
    fill: "url(#paint31_radial_704_7017)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7831 59.7184L51.1501 17.4184C46.6326 15.9126 40.7462 15.2281 35.1336 15.2281C35.2705 17.4184 34.3122 19.1981 32.3957 20.4301C30.753 21.5252 28.5627 21.6621 26.6462 20.7039L20.486 32.4767C15.421 42.4699 19.8016 53.1476 26.7831 59.7184Z",
    fill: "url(#paint32_radial_704_7017)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.6461 20.0196C45.8131 18.9245 41.5694 18.3769 37.5995 18.24C37.0519 20.1565 35.8199 21.7992 34.0403 22.8944C32.2606 24.1264 30.2073 24.5371 28.1539 24.2633L23.0888 33.9827C18.8451 42.0594 22.1306 51.0944 28.1539 57.1177C36.5043 59.3079 45.8131 57.6652 50.7412 49.8623L56.6276 40.6905C55.3956 39.0478 54.7111 36.9944 54.848 34.8041C54.9849 32.7507 55.8063 30.8342 57.0383 29.3283C55.1218 26.1798 52.5208 22.6206 49.6461 20.0196Z",
    fill: "url(#paint33_linear_704_7017)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.6465 20.0197L28.1543 57.1177C36.5048 59.308 45.8135 57.6653 50.7417 49.8624L56.6281 40.6905C55.396 39.0478 54.7116 36.9944 54.8485 34.8041C54.9854 32.7507 55.8067 30.8342 57.0388 29.3284C55.1223 26.1798 52.5213 22.6206 49.6465 20.0197Z",
    fill: "url(#paint34_linear_704_7017)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0882 49.8623C28.9746 39.3215 35.1348 28.7807 41.295 18.3768C41.1581 18.3768 40.8844 18.3768 40.7475 18.3768C34.9979 28.7807 29.1115 39.1846 22.8145 49.3147C22.9513 49.5885 23.0882 49.7254 23.0882 49.8623Z",
    fill: "#1D71B8"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.3729 19.8827C42.3914 32.34 35.2729 44.6604 28.0176 56.8439L28.1545 56.9808C28.2914 56.9808 28.2914 56.9808 28.4283 56.9808C35.4098 44.5235 42.5283 32.2031 49.7836 20.0196L49.6467 19.8827C49.5098 19.8827 49.5098 19.8827 49.3729 19.8827Z",
    fill: "#1D71B8"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.916 57.939C43.0762 47.5352 49.0995 36.9944 55.1228 26.4536C55.2597 26.5905 55.3966 26.7274 55.3966 26.8643C49.2364 37.1313 43.2131 47.3983 37.4636 57.8022C37.3267 57.8022 37.1898 57.939 36.916 57.939Z",
    fill: "#722935"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.8837 20.8409C41.8419 20.2933 45.1273 20.9777 46.0856 21.3884C46.4963 21.5253 46.907 21.7991 47.0438 22.2098C47.4545 22.6205 47.4545 23.168 47.3176 23.7156C48.0021 22.4836 48.6866 21.2515 49.371 20.0195C46.7701 19.1981 44.0322 18.7875 41.2943 18.5137C40.473 20.0195 39.5147 21.5253 38.6934 23.0311C39.2409 22.0729 40.0623 21.2515 40.8837 20.8409Z",
    fill: "url(#paint35_radial_704_7017)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.3413 27.9594C53.3413 26.8643 51.0141 24.4002 50.1928 23.7157C49.7821 23.4419 49.3714 23.305 48.9607 23.1681C48.4132 23.0313 48.0025 23.305 47.5918 23.7157C48.4132 22.6206 49.0976 21.3885 49.7821 20.1565C51.6986 21.9361 53.4782 24.1264 55.1209 26.4536C54.2996 27.9594 53.3413 29.4652 52.52 30.9711C52.9306 30.0128 53.3413 28.9177 53.3413 27.9594Z",
    fill: "url(#paint36_radial_704_7017)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6073 54.5168C25.9646 53.2848 24.7326 50.5469 24.7326 48.4935C24.7326 47.6721 24.8695 46.8508 25.1432 46.0294C24.4588 47.2615 23.7743 48.4935 23.0898 49.7255C24.3219 52.3265 25.9646 54.6537 28.018 56.7071C28.4287 56.2964 28.8394 55.6119 29.1131 54.9275C28.7025 55.2013 28.4287 55.2013 27.6073 54.5168Z",
    fill: "url(#paint37_radial_704_7017)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6161 56.2962C32.5326 57.1176 35.5442 56.7069 37.1869 55.7487C38.0083 55.338 38.5559 54.7904 39.1035 54.106C38.419 55.338 37.5976 56.57 36.9132 57.8021C34.0384 58.0759 31.1636 57.8021 28.4258 56.9807C28.8365 56.2962 29.1102 55.7487 29.5209 55.0642C29.5209 55.6118 29.7947 55.8856 30.6161 56.2962Z",
    fill: "url(#paint38_radial_704_7017)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2244 44.9342C21.5817 42.4701 21.9924 37.8158 22.8138 34.6672C20.6235 39.5954 20.8973 44.6604 22.9507 49.3148C23.6351 48.0828 24.4565 46.7138 25.2778 45.4818C24.5934 45.8925 23.9089 46.0294 23.2244 44.9342Z",
    fill: "url(#paint39_radial_704_7017)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.1588 55.338C44.1705 55.4749 48.0035 52.8739 50.3307 50.5468C47.1821 54.9273 42.5278 57.1176 37.5996 57.8021C38.2841 56.4332 39.1054 55.2011 39.7899 53.8322C39.653 54.6536 39.9268 55.338 41.1588 55.338Z",
    fill: "url(#paint40_radial_704_7017)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.1474 22.8944C38.4212 21.6623 37.463 22.3468 36.2309 23.4419C33.2193 26.1798 31.3028 26.5905 28.8387 27.2749C26.9222 27.8225 26.2377 28.3701 25.1426 29.739L28.0173 24.2633C30.0707 24.5371 32.1241 24.1264 33.9037 22.8944C35.6834 21.7992 36.9154 20.1565 37.463 18.24C37.8736 18.24 38.1474 18.24 38.5581 18.24C39.2426 18.24 39.927 18.3769 40.6115 18.3769C39.927 19.8827 39.1057 21.3885 38.1474 22.8944Z",
    fill: "url(#paint41_radial_704_7017)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1836 46.7138C25.9632 43.2915 28.2904 39.1847 30.8914 34.6672C33.4923 30.1497 35.9564 26.1798 38.0098 22.8944C36.2302 26.3167 33.903 30.4235 31.302 34.941C28.7011 39.3216 26.237 43.4284 24.1836 46.7138Z",
    fill: "#99FFFF"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4258 55.7488C31.0268 50.9576 34.3122 45.0712 38.0083 38.7741C41.5675 32.477 44.9899 26.7275 47.8646 22.0731C45.2636 26.8644 41.9782 32.7508 38.2821 39.0479C34.7229 45.345 31.3005 51.0945 28.4258 55.7488Z",
    fill: "#99FFFF"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4199 54.9274C40.1995 51.5051 42.5267 47.3983 45.1277 42.8808C47.7287 38.5003 50.1927 34.3935 52.2461 31.108C50.4665 34.5304 48.1393 38.6372 45.5384 43.1546C42.9374 47.5352 40.4733 51.642 38.4199 54.9274Z",
    fill: "#FF886C"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    },
    opacity: 0.5
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.2951 22.7575C39.7893 24.4003 38.6942 26.1799 37.599 28.0964C34.4505 33.0245 30.3437 39.5954 28.2903 45.0711C27.7427 46.577 27.332 48.0828 27.1951 49.7255C27.0583 51.0944 28.1534 55.3381 29.6592 52.7371C33.2184 46.577 36.7777 40.4168 40.3369 34.2566C42.3903 30.8342 44.5806 27.275 46.4971 23.8527C47.5922 21.5255 43.2116 20.5672 41.2951 22.7575Z",
    fill: "url(#paint42_radial_704_7017)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    }
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.9731 30.1497C48.9614 35.4885 42.1168 47.5351 39.6527 51.6419C38.8313 53.0108 37.4624 53.9691 36.2304 54.9273C35.1352 55.7487 31.0284 56.9807 32.3974 54.2429C37.1886 45.3448 42.8012 35.2147 48.5508 26.0429C49.9197 23.9895 53.4789 27.4118 51.9731 30.1497Z",
    fill: "url(#paint43_radial_704_7017)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    },
    opacity: 0.5
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9026 28.2331C34.0395 28.0962 33.9026 27.6856 33.7657 27.6856C32.6706 27.138 30.7541 27.8225 29.7958 28.37C29.1114 28.9176 28.5638 29.6021 28.1531 30.4234C25.8259 34.3933 24.457 37.1312 23.9094 41.7856C23.6356 43.9759 24.7308 44.6603 26.0997 42.3331C28.8376 37.5419 31.4385 32.8875 33.9026 28.2331Z",
    fill: "url(#paint44_radial_704_7017)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    }
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.7399 38.774C48.5496 42.1963 43.3477 50.9575 43.3477 52.4633C43.3477 53.5585 44.5797 53.2847 45.2642 53.1478C46.6331 52.7371 48.2758 51.6419 49.2341 50.6837C50.7399 49.041 53.204 45.208 53.6146 43.0177C53.8884 41.5118 53.4778 34.5303 50.7399 38.774Z",
    fill: "url(#paint45_radial_704_7017)"
  }))), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.772 34.8038L28.8371 25.0844L28.1526 24.2631L23.0875 33.9825C19.6652 40.4165 21.171 47.6718 25.1409 53.4213C21.5817 47.8087 20.4866 41.1009 23.772 34.8038Z",
    fill: "url(#paint46_linear_704_7017)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6999 25.0845C30.7533 25.3582 32.8067 24.9476 34.5863 23.7155C36.3659 22.6204 37.598 20.9777 38.1455 19.0612L37.598 18.1029C37.0504 20.0194 35.8184 21.6621 34.0388 22.7573C32.2591 23.9893 30.2057 24.4 28.1523 24.1262L28.6999 25.0845Z",
    fill: "url(#paint47_linear_704_7017)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.2841 19.0612C42.254 19.1981 46.4977 19.7456 50.3307 20.8408C52.6579 23.0311 54.8482 25.7689 56.6278 28.5068C54.7113 25.4951 52.2472 22.3466 49.6462 19.8825C45.8132 18.7874 41.5695 18.2398 37.5996 18.1029L38.2841 19.0612Z",
    fill: "url(#paint48_linear_704_7017)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3848 21.3883C32.1226 21.6621 35.2712 20.1563 36.5032 16.5971C37.5984 15.2281 42.3896 15.6388 44.7168 15.9126C41.7052 15.5019 38.4197 15.2281 35.1343 15.2281C35.2712 17.4184 34.3129 19.1981 32.3964 20.4301C31.5751 20.9777 30.4799 21.3883 29.3848 21.3883Z",
    fill: "url(#paint49_radial_704_7017)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6462 22.0728C27.0569 21.3883 27.7414 21.2514 28.4258 21.2514C27.8783 21.2514 27.1938 21.1145 26.6462 20.7039L20.486 32.4767C17.2006 38.9107 17.7482 45.4815 20.486 51.231C19.5278 48.6301 18.7064 46.166 18.7064 43.4281C18.7064 37.2679 19.5278 34.8039 26.6462 22.0728Z",
    fill: "url(#paint50_radial_704_7017)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3317 25.9058C27.7424 25.7689 27.8793 26.3165 27.6055 26.7271C26.921 28.233 26.0997 29.7388 25.4152 31.1077C23.2249 35.4883 22.1298 36.9941 21.5822 42.0592C21.4453 42.7436 21.4453 43.2912 21.4453 43.9757C21.856 47.398 23.2249 50.5466 25.2783 53.4213C21.7191 47.8087 20.624 41.1009 23.9094 34.8038L28.9744 25.0844L28.1531 24.2631L27.3317 25.9058Z",
    fill: "url(#paint51_radial_704_7017)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.824 17.2817C49.5084 17.9661 49.5084 19.3351 48.2764 19.472C48.0026 19.472 47.8657 19.472 47.5919 19.472C48.2764 19.6089 48.9609 19.8826 49.6453 20.0195L51.1512 17.4186C49.5084 16.871 47.8657 16.4603 45.9492 16.1865C47.0444 16.3234 48.1395 16.5972 48.824 17.2817Z",
    fill: "url(#paint52_radial_704_7017)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2347 56.0223C26.5084 56.7067 25.824 57.9388 25.0026 57.3912C24.5919 57.1174 24.3182 56.8436 24.0444 56.5698C24.8657 57.665 25.824 58.7601 26.9191 59.5815L28.4249 56.9805C26.0978 54.6533 24.1813 51.9155 22.9492 48.9038C23.4968 50.8203 24.455 52.463 25.4133 54.2426C25.6871 54.9271 25.9609 55.6116 26.2347 56.0223Z",
    fill: "url(#paint53_radial_704_7017)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1925 60.9506L26.6449 59.7185C24.0439 57.2545 21.7168 54.1059 20.2109 50.6836C21.7168 54.6535 24.3177 58.2127 27.1925 60.9506Z",
    fill: "#234368"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.9135 19.7456C37.4611 19.8825 37.3242 20.567 36.9135 21.2514C35.4077 23.4417 32.9436 25.2214 30.2057 24.9476C29.6582 24.9476 29.2475 24.5369 29.3844 24.2631C28.9737 24.2631 28.563 24.2631 28.1523 24.1262L28.6999 25.0845C30.7533 25.3582 32.8067 24.9476 34.5863 23.7155C36.3659 22.6204 37.598 20.9777 38.1455 19.0612L37.598 18.1029C37.4611 18.7874 37.1873 19.3349 36.9135 19.7456Z",
    fill: "url(#paint54_radial_704_7017)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.5907 19.3351C48.0014 19.472 48.8227 20.1564 47.5907 20.0195C46.9062 19.8827 46.2218 19.7458 45.4004 19.6089C44.0315 19.472 42.6625 19.3351 41.4305 19.1982C41.0198 19.1982 40.4722 19.0613 40.0616 19.0613C39.3771 18.9244 38.9664 18.6506 38.9664 18.3768C38.5557 18.3768 38.1451 18.3768 37.7344 18.3768L38.2819 19.3351C42.2519 19.472 46.4955 20.0195 50.3285 21.1147C52.6557 23.305 54.846 26.0429 56.6256 28.7807C54.7091 25.7691 52.2451 22.6205 49.6441 20.1564C48.9596 19.7458 48.2752 19.6089 47.5907 19.3351Z",
    fill: "url(#paint55_radial_704_7017)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.5612 18.6505C51.6981 18.6505 51.6981 18.6505 51.5612 18.6505C51.9719 18.5136 52.2457 18.6505 52.3826 18.6505C51.9719 18.2398 51.4243 17.8291 51.0136 17.4185L50.4661 18.3767L49.5078 20.0194L49.6447 20.1563C51.5612 21.9359 53.3408 24.1262 54.9835 26.4534C55.1204 26.5903 55.2573 26.7272 55.2573 26.8641L55.3942 27.001C54.5729 25.2214 52.5195 22.4835 51.2874 20.7039C51.0136 20.2932 51.0136 20.0194 51.0136 19.8825C51.0136 19.6087 51.2874 18.9243 51.5612 18.6505Z",
    fill: "url(#paint56_radial_704_7017)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.4609 61.635C36.6395 61.635 36.5026 61.2243 36.7764 60.8136C33.3541 61.0874 29.9317 60.6768 26.7832 59.7185L27.3308 60.9505C36.3657 63.6884 47.8648 62.1826 53.8881 52.7369L60.8696 41.6486C60.8696 41.2379 60.5958 40.5534 60.4589 40.2797L59.7745 41.3748C60.0482 42.0593 59.9114 42.6068 59.2269 43.5651C58.1317 45.3447 55.6677 49.4515 53.4774 52.4632C52.1084 54.3797 50.4657 56.1593 48.6861 57.6651C45.8114 59.9923 41.2939 61.9088 37.4609 61.635Z",
    fill: "url(#paint57_radial_704_7017)"
  }))), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7728 63.1407H19.666L22.4039 65.8786L23.7728 63.1407Z",
    fill: "#B51015"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4603 33.0243H33.3535L36.0914 35.7622L37.4603 33.0243Z",
    fill: "#0889D6"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9955 16.597H53.8887L56.6265 19.3349L57.9955 16.597Z",
    fill: "#0889D6"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1336 55.4164L18.1094 56.4932L19.5101 56.4581L19.1336 55.4164Z",
    fill: "#0889D6"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8055 13.8592L49.7812 14.936L51.1819 14.901L50.8055 13.8592Z",
    fill: "#0889D6"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6356 64.8822L26.6016 62.1144L26.779 65.9822L29.6356 64.8822Z",
    fill: "#B51015"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3895 52.2192L28.3555 49.4514L28.533 53.3193L31.3895 52.2192Z",
    fill: "#B51015"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_704_7017",
    x1: 27.2319,
    y1: 60.9339,
    x2: 51.6458,
    y2: 18.6478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F5078"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#456A97"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_704_7017",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(68.3041 54.0232) scale(42.101 42.101)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADCAEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#527499"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_704_7017",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.21768 0.456432) scale(67.2677 67.2677)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCFBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6084AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_704_7017",
    x1: 24.6512,
    y1: 30.2741,
    x2: 38.8695,
    y2: 38.4832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0FB1F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_704_7017",
    x1: 38.9318,
    y1: 38.5189,
    x2: 53.2122,
    y2: 46.7637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A80000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D43500"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_704_7017",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.3408 27.7029) scale(13.3323 13.3323)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 7e-8,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1136,
    stopColor: "#F9FAFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2599,
    stopColor: "#E9ECF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4244,
    stopColor: "#CFD5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6019,
    stopColor: "#AAB6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#7A8DA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9843,
    stopColor: "#415B80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C577D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_704_7017",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.0184 29.1564) scale(12.2454)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 7e-8,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1136,
    stopColor: "#FBF9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2599,
    stopColor: "#F1E9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4244,
    stopColor: "#DFCFCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6019,
    stopColor: "#C6AAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#A67A7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9843,
    stopColor: "#804142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D3C3D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_704_7017",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.784 49.6823) scale(9.44591 9.4459)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 7e-8,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1136,
    stopColor: "#F9FAFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2599,
    stopColor: "#E9ECF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4244,
    stopColor: "#CFD5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6019,
    stopColor: "#AAB6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#7A8DA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9843,
    stopColor: "#415B80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C577D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_704_7017",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.7159 49.9117) scale(11.7861 11.7861)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 7e-8,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1136,
    stopColor: "#FBF9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2599,
    stopColor: "#F1E9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4244,
    stopColor: "#DFCFCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6019,
    stopColor: "#C6AAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#A67A7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9843,
    stopColor: "#804142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D3C3D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_704_7017",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.745 43.131) scale(8.91503)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 7e-8,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1136,
    stopColor: "#F9FAFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2599,
    stopColor: "#E9ECF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4244,
    stopColor: "#CFD5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6019,
    stopColor: "#AAB6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#7A8DA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9843,
    stopColor: "#415B80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C577D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_704_7017",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.6752 47.8268) scale(13.2738 13.2739)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 7e-8,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1136,
    stopColor: "#FBF9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2599,
    stopColor: "#F1E9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4244,
    stopColor: "#DFCFCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6019,
    stopColor: "#C6AAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#A67A7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9843,
    stopColor: "#804142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D3C3D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_704_7017",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(63.9958 39.0944) scale(28.6558 28.6559)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 2.3e-7,
    stopColor: "#7D3C3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0156761,
    stopColor: "#804142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A67A7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3981,
    stopColor: "#C6AAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5756,
    stopColor: "#DFCFCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7401,
    stopColor: "#F1E9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8864,
    stopColor: "#FBF9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_704_7017",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.9532 19.0696) scale(16.704 16.704)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 2.3e-7,
    stopColor: "#3C577D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0156761,
    stopColor: "#415B80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#7A8DA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3981,
    stopColor: "#AAB6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5756,
    stopColor: "#CFD5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7401,
    stopColor: "#E9ECF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8864,
    stopColor: "#F9FAFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_704_7017",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.8156 42.6663) scale(33.3933 33.3933)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_704_7017",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.2573 45.1388) scale(24.7804 24.7804)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D44660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_704_7017",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.214 42.4179) scale(24.5218)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1102,
    stopColor: "#00FAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2341,
    stopColor: "#00EDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3647,
    stopColor: "#00D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4999,
    stopColor: "#00B7B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6388,
    stopColor: "#008E8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7807,
    stopColor: "#005C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9223,
    stopColor: "#002323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_704_7017",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.5337 50.2302) scale(20.1778 20.1778)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D44660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_704_7017",
    x1: 20.6906,
    y1: 28.5236,
    x2: 32.5867,
    y2: 49.1282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C86B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F5078"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_704_7017",
    x1: 30.6714,
    y1: 26.2459,
    x2: 35.9115,
    y2: 17.1699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F5078"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#456A97"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_704_7017",
    x1: 37.6628,
    y1: 23.3714,
    x2: 56.6145,
    y2: 23.3714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73A2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F5078"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_704_7017",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.3091 9.83334) scale(14.5044 14.5044)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1114,
    stopColor: "#ECFAFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2367,
    stopColor: "#DFEDEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3687,
    stopColor: "#C9D6DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5054,
    stopColor: "#ABB7BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6457,
    stopColor: "#848E9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7892,
    stopColor: "#545C6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9324,
    stopColor: "#1D233A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00051F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_704_7017",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.8569 21.1804) scale(24.9871 24.9871)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1114,
    stopColor: "#ECFAFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2367,
    stopColor: "#DFEDEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3687,
    stopColor: "#C9D6DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5054,
    stopColor: "#ABB7BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6457,
    stopColor: "#848E9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7892,
    stopColor: "#545C6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9324,
    stopColor: "#1D233A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00051F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_704_7017",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.4263 31.0326) scale(16.4743)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5149,
    stopColor: "#F0FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7692,
    stopColor: "#B4D1F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BA4E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_704_7017",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.7596 20.7156) scale(11.13 11.13)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1114,
    stopColor: "#ECFAFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2367,
    stopColor: "#DFEDEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3687,
    stopColor: "#C9D6DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5054,
    stopColor: "#ABB7BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6457,
    stopColor: "#848E9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7892,
    stopColor: "#545C6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9324,
    stopColor: "#1D233A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00051F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_704_7017",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.7989 58.5143) scale(16.3007 16.3007)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1114,
    stopColor: "#ECFAFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2367,
    stopColor: "#DFEDEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3687,
    stopColor: "#C9D6DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5054,
    stopColor: "#ABB7BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6457,
    stopColor: "#848E9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7892,
    stopColor: "#545C6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9324,
    stopColor: "#1D233A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00051F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_704_7017",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.2533 16.9355) scale(8.588)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5149,
    stopColor: "#F0FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7692,
    stopColor: "#B4D1F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BA4E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_704_7017",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.3417 8.66756) scale(15.6416 15.6416)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5149,
    stopColor: "#F0FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7692,
    stopColor: "#B4D1F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BA4E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_704_7017",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.4334 20.1224) scale(9.04276 9.04276)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5149,
    stopColor: "#F0FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7692,
    stopColor: "#B4D1F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BA4E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_704_7017",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(65.2869 38.6658) scale(10.5816 10.5816)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5149,
    stopColor: "#F0FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7692,
    stopColor: "#B4D1F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BA4E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_704_7017",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.0424 32.9912) scale(30.0513)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5149,
    stopColor: "#F0FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7692,
    stopColor: "#B4D1F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BA4E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_704_7017",
    x1: 27.2299,
    y1: 60.9341,
    x2: 51.6439,
    y2: 18.6479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F5078"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#456A97"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_704_7017",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(68.3021 54.0233) scale(42.101 42.101)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADCAEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#527499"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_704_7017",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.21573 0.456554) scale(67.2677 67.2677)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCFBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6084AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_704_7017",
    x1: 24.6492,
    y1: 30.2743,
    x2: 38.8675,
    y2: 38.4833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0FB1F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_704_7017",
    x1: 38.9298,
    y1: 38.519,
    x2: 53.2103,
    y2: 46.7638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A80000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D43500"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_704_7017",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.3388 27.703) scale(13.3323 13.3323)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 7e-8,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1136,
    stopColor: "#F9FAFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2599,
    stopColor: "#E9ECF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4244,
    stopColor: "#CFD5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6019,
    stopColor: "#AAB6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#7A8DA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9843,
    stopColor: "#415B80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C577D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_704_7017",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.0164 29.1565) scale(12.2454)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 7e-8,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1136,
    stopColor: "#FBF9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2599,
    stopColor: "#F1E9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4244,
    stopColor: "#DFCFCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6019,
    stopColor: "#C6AAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#A67A7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9843,
    stopColor: "#804142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D3C3D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_704_7017",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.782 49.6824) scale(9.44591 9.4459)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 7e-8,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1136,
    stopColor: "#F9FAFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2599,
    stopColor: "#E9ECF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4244,
    stopColor: "#CFD5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6019,
    stopColor: "#AAB6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#7A8DA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9843,
    stopColor: "#415B80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C577D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_704_7017",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.714 49.9118) scale(11.7861 11.7861)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 7e-8,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1136,
    stopColor: "#FBF9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2599,
    stopColor: "#F1E9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4244,
    stopColor: "#DFCFCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6019,
    stopColor: "#C6AAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#A67A7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9843,
    stopColor: "#804142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D3C3D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_704_7017",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.743 43.1312) scale(8.91503)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 7e-8,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1136,
    stopColor: "#F9FAFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2599,
    stopColor: "#E9ECF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4244,
    stopColor: "#CFD5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6019,
    stopColor: "#AAB6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#7A8DA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9843,
    stopColor: "#415B80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C577D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_704_7017",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.6733 47.827) scale(13.2738 13.2739)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 7e-8,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1136,
    stopColor: "#FBF9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2599,
    stopColor: "#F1E9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4244,
    stopColor: "#DFCFCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6019,
    stopColor: "#C6AAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#A67A7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9843,
    stopColor: "#804142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D3C3D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_704_7017",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.9512 19.0697) scale(16.704 16.704)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 2.3e-7,
    stopColor: "#3C577D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0156761,
    stopColor: "#415B80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#7A8DA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3981,
    stopColor: "#AAB6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5756,
    stopColor: "#CFD5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7401,
    stopColor: "#E9ECF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8864,
    stopColor: "#F9FAFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_704_7017",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.8136 42.6665) scale(33.3933 33.3933)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_704_7017",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.2554 45.1389) scale(24.7804 24.7804)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D44660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_704_7017",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.2121 42.418) scale(24.5218)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1102,
    stopColor: "#00FAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2341,
    stopColor: "#00EDED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3647,
    stopColor: "#00D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4999,
    stopColor: "#00B7B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6388,
    stopColor: "#008E8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7807,
    stopColor: "#005C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9223,
    stopColor: "#002323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_704_7017",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.5317 50.2303) scale(20.1778 20.1778)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D44660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_704_7017",
    x1: 20.6886,
    y1: 28.5237,
    x2: 32.5848,
    y2: 49.1283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C86B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F5078"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_704_7017",
    x1: 30.6694,
    y1: 26.246,
    x2: 35.9095,
    y2: 17.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F5078"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#456A97"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_704_7017",
    x1: 37.6608,
    y1: 23.3715,
    x2: 56.6126,
    y2: 23.3715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73A2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F5078"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_704_7017",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.3072 9.83346) scale(14.5044 14.5044)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1114,
    stopColor: "#ECFAFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2367,
    stopColor: "#DFEDEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3687,
    stopColor: "#C9D6DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5054,
    stopColor: "#ABB7BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6457,
    stopColor: "#848E9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7892,
    stopColor: "#545C6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9324,
    stopColor: "#1D233A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00051F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_704_7017",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.8549 21.1805) scale(24.9871 24.9871)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1114,
    stopColor: "#ECFAFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2367,
    stopColor: "#DFEDEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3687,
    stopColor: "#C9D6DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5054,
    stopColor: "#ABB7BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6457,
    stopColor: "#848E9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7892,
    stopColor: "#545C6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9324,
    stopColor: "#1D233A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00051F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_704_7017",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.4243 31.0327) scale(16.4743)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5149,
    stopColor: "#F0FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7692,
    stopColor: "#B4D1F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BA4E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_radial_704_7017",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.7576 20.7158) scale(11.13 11.13)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1114,
    stopColor: "#ECFAFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2367,
    stopColor: "#DFEDEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3687,
    stopColor: "#C9D6DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5054,
    stopColor: "#ABB7BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6457,
    stopColor: "#848E9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7892,
    stopColor: "#545C6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9324,
    stopColor: "#1D233A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00051F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_radial_704_7017",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.7969 58.5144) scale(16.3007 16.3007)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1114,
    stopColor: "#ECFAFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2367,
    stopColor: "#DFEDEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3687,
    stopColor: "#C9D6DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5054,
    stopColor: "#ABB7BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6457,
    stopColor: "#848E9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7892,
    stopColor: "#545C6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9324,
    stopColor: "#1D233A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00051F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial_704_7017",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.2513 16.9356) scale(8.588)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5149,
    stopColor: "#F0FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7692,
    stopColor: "#B4D1F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BA4E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_radial_704_7017",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.3398 8.66768) scale(15.6416 15.6416)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5149,
    stopColor: "#F0FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7692,
    stopColor: "#B4D1F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BA4E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint56_radial_704_7017",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.4315 20.1225) scale(9.04276 9.04276)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5149,
    stopColor: "#F0FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7692,
    stopColor: "#B4D1F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BA4E1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint57_radial_704_7017",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.0405 32.9913) scale(30.0513)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5149,
    stopColor: "#F0FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7692,
    stopColor: "#B4D1F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BA4E1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSta2);
export default __webpack_public_path__ + "static/media/sta_2.8816ff9cf874ae3de7d457c0e18bee40.svg";
export { ForwardRef as ReactComponent };